import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import "./index.scss";
import { Col, Row } from "react-bootstrap";
import NavLayout from "../../layout/navLayout";
import NoDataFound from "../../components/NoDataFound";
import PageFilterHeader from "../../components/pageFilterHeader";
import RenewalCard from "./components/renewalCard";
import { getRenewalListing } from "../../service/renewal/renewalService";

function RenewalList() {
  const renewalData = useSelector((state) => state.renewal.renewalData);

  useEffect(() => {
    getRenewalListing();
  }, []);

  return (
    <NavLayout>
      <div>
        <PageFilterHeader
          title="Renewal"
        />
        <div>
          {/* {loading ? (
            <Loader />
          ) : ( */}
          {/* )} */}
          <Row>
            {Array.isArray(renewalData) && renewalData.length > 0 ? (
              renewalData.map((data, index) => {
                return (
                  <Col xs={12} sm={6} lg={4} key={index}>
                    <RenewalCard renewalData={data} />
                  </Col>
                );
              })
            ) : (
              <NoDataFound />
            )}
          </Row>
        </div>
      </div>
    </NavLayout>
  );
}

export default RenewalList;
